<template>
  <v-switch
    :input-value="value"
    :color="color"
    :label="label"
    :readonly="readonly"
    :class="cssClass"
  />
</template>

<script>
  export default {
    name: "PsSwitch",
    props: {
      value: {
        type: Boolean, // if it exists = show
        default: false
      },
      label: {
        type: String,
        default: null
      },
      color: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      cssClass: {
        type: String,
        default: null
      }
    }
  };
</script>
